import { useCurrentInventoryId } from "../url";
import { useListProjects } from "./usePouchList";

export function useCurrentInventory() {
  const { inventoryId } = useCurrentInventoryId();

  const projectsList = useListProjects();
  const foundProject =
    inventoryId === undefined ? undefined : projectsList.data?.find((p) => p.inventories && inventoryId in p.inventories);

  return {
    data:
      inventoryId && foundProject && foundProject.inventories && inventoryId in foundProject.inventories
        ? foundProject.inventories[inventoryId]
        : null,
    loading: projectsList.loading,
    error: projectsList.error,
  };
}
